import React from 'react'
import styles from './Text.module.css'

const h1=(props)=>{
	return(
		<h1 className={styles.H1}>{props.children}</h1>
	)
}

export default h1;
